import { universalEach } from "@faedev/editor-utils";
import profileNameText from "src/functions/profileNameText";
import { ApiLectures } from "src/types/ApiLectures";
import { ApiProfile } from "src/types/ApiProfile";
import { ApiPrograms } from "src/types/ApiPrograms";
import { ApiVideoCard } from "src/types/ApiVideoCard";

export function mapContentToVideoCards(
  data: ApiLectures | ApiPrograms | any,
  profile?: ApiProfile | null | undefined
): ApiVideoCard[] {
  return (
    data !== undefined &&
    universalEach(data, (item) => {
      return (
        item !== undefined && {
          id: item?.id,
          verified: item?.verified,
          blocked: item?.blocked,
          private: item?.private,
          paid: item?.paid,
          isPaid: item?.isPaid,
          subscription: item?.subscription,
          title: item?.title,
          url: item?.slug,
          locale: item?.locale,
          label: item?.label,
          difficulty: item?.difficulty,
          practice_styles: item?.practice_styles,
          practice_skills: item?.practice_skills,
          practice_body_parts: item?.practice_body_parts,
          practice_equipments: item?.practice_equipments,
          practice_focuses: item?.practice_focuses,
          duration: item?.duration,
          views: item?.views,
          rating: item?.rating,
          thumbnail: item?.thumbnail,
          video: item?.video,
          tags: item?.tags,
          order: item?.order,
          playlist_order: item?.playlist_order,
          contentType: item?.content_type ?? "serie",
          profile:
            item?.profiles && item?.profiles.length > 0
              ? {
                  nickname: profileNameText(
                    item?.profiles[0]?.client?.name,
                    item?.profiles[0]?.client?.surname,
                    item?.profiles[0]?.nickname,
                    item?.profiles[0]?.type
                  ),
                  url: item?.profiles[0]?.slug,
                }
              : profile
              ? {
                  nickname: profileNameText(
                    profile?.client?.name,
                    profile?.client?.surname,
                    profile?.nickname,
                    profile?.type
                  ),
                  url: profile?.slug,
                }
              : { nickname: ``, url: `#` },
        }
      );
    })
  );
}
